export { default as WReportHeader } from '@/widgets/WReportHeader/WReportHeader.vue'
